import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';

const CoreSpinner = ({ loading }) => {
  return (
    <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={loading}
    >
      <CircularProgress size={100} style={{ margin: 'auto', marginLeft: "45%", color: '#6c85d7' }} />
    </Backdrop>
  )
}

export default CoreSpinner;